import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border-2 px-2.5 py-0.5 text-xs font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring/50 focus:ring-offset-2 shadow-sm",
  {
    variants: {
      variant: {
        /* Primary - Coral vibrante com sombra */
        default: "border-transparent bg-primary text-primary-foreground shadow-[0_1px_4px_-1px_hsl(var(--primary)/0.4)] hover:bg-primary/95 hover:shadow-[0_2px_6px_-2px_hsl(var(--primary)/0.5)]",
        
        /* Secondary - Terracota */
        secondary: "border-transparent bg-secondary text-secondary-foreground shadow-[0_1px_4px_-1px_hsl(var(--secondary)/0.4)] hover:bg-secondary/95",
        
        /* Destructive - Vermelho alerta */
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow-[0_1px_4px_-1px_hsl(var(--destructive)/0.4)] hover:bg-destructive/95",
        
        /* Outline - Borda definida */
        outline: "border-border bg-background text-foreground hover:bg-muted/60 hover:border-primary/40",
        
        /* Success - Verde confirmado */
        success: "border-transparent bg-success text-success-foreground shadow-[0_1px_4px_-1px_hsl(var(--success)/0.4)] hover:bg-success/95",
        
        /* Warning - Âmbar */
        warning: "border-transparent bg-warning text-warning-foreground shadow-[0_1px_4px_-1px_hsl(var(--warning)/0.4)] hover:bg-warning/95",
        
        /* Info - Azul */
        info: "border-transparent bg-info text-info-foreground shadow-[0_1px_4px_-1px_hsl(var(--info)/0.4)] hover:bg-info/95",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
